import { formatarMoeda } from '../lib/formatos'

// ▶ O que uma linha de preco DIZ quando a ficha esta so mostrando.
//
// ⛔ A REGRA QUE ESTE MODULO EXISTE PARA PRENDER: preco ausente vira "sem preco"
// POR EXTENSO, nunca "0,00". Numero dentro de um campo rotulado "Preco" nao se
// le como exemplo, le-se como preco -- foi assim que a ficha do produto 568
// pareceu custar zero enquanto o card dizia R$ 22,50 (conserto 789ec46).
//
// ⚠ `!= null` pega null E undefined, e os dois importam: `null` e "esta tabela
// nao tem preco", e `undefined` e a linha de `precos` em cache de antes da 0021,
// que nao tem a chave. Um `!== null` aqui escreveria "R$ NaN" no aparelho de
// quem nao sincronizou -- foi essa armadilha que derrubou a tela do pedido
// inteira em 18/08.
export function textoDoPrecoNaFicha(valor: number | null | undefined): string {
  return valor != null ? formatarMoeda(valor) : 'sem preço'
}

// A mesma regra para as quantidades minima e maxima, que nao sao dinheiro e por
// isso nao passam por `formatarMoeda`. A frase de vazio vem de fora porque a
// tela ja diz "sem minimo" e "sem maximo", e sao diferentes.
export function textoDaRegraNaFicha(
  quantidade: number | null | undefined,
  vazio: string,
): string {
  return quantidade != null ? String(quantidade) : vazio
}
